import {
    EditButton,
    FunctionField, ReferenceField,
    Show,
    SimpleShowLayout,
    TextField, TopToolbar
} from "react-admin";
import {Typography} from "@material-ui/core";
import {ImageField} from "../ImageField";
import {languages} from "../../utils/Utils";
import * as React from "react";
import {useState} from "react";

export const RangeShow = (props) => {

    const [merchantConfig] = useState(JSON.parse(localStorage.getItem('merchantConfig')));

    return (
        <Show {...props} actions={<RangeShowActions/>} title={"Gamme"}>
            <SimpleShowLayout>
                <FunctionField
                    label={""}
                    source={"id"}
                    render={record =>
                        <Typography variant={"h4"}>
                            Gamme : {record.code}
                        </Typography>
                    }
                />
                <FunctionField
                    label={""}
                    source={"idd"}
                    render={record =>
                        <div>Nombre de produits dans la gamme : {record.nbItems}</div>
                    }
                />
                <FunctionField
                    render={record => <ImageField
                        path={record.imagePath}
                        alt={"Category"}
                        height={200}
                    />}
                    label={"Image"}/>
                <ReferenceField
                    label="Catégorie"
                    source="categoryId"
                    reference="categories"
                    link={false}
                >
                    <TextField source="content[0].name"/>
                </ReferenceField>
                {
                    merchantConfig.enabledLanguages.map((language, idx) =>
                        <div key={language}>
                            <FunctionField
                                label={""}
                                source={"content[" + idx + "].language"}
                                render={
                                    record => {
                                        if (record.content === undefined || record.content.length <= idx) {
                                            return "";
                                        }
                                        return <h3>{languages[record.content[idx].language]}</h3>
                                    }
                                }
                            />
                            <TextField
                                style={{display: "none"}}
                                initialvalue={language}
                                source={"content[" + idx + "].language"}
                            />
                            <span style={{fontWeight: 'bold', fontSize: 14}}>Nom : </span>
                            <TextField
                                label={"Nom"}
                                source={"content[" + idx + "].name"}
                            />
                            <br/>
                            <br/>
                        </div>
                    )
                }
            </SimpleShowLayout>
        </Show>
    )
};

const RangeShowActions = (
    {
        basepath, data, resource
    }
) => (
    <TopToolbar>
        <EditButton basepath={basepath} record={data}/>
    </TopToolbar>
);